import { Component } from "react";
import { injectIntl } from "react-intl";
import { intlShape } from "../../shapes";

import ConfirmationModal from "../ConfirmationModal";

import ActionButton from "./ActionButton";

type Props = {
  id?: string;
  disabled?: boolean;
  label?: string;
  modalTitle?: string;
  modalMessage?: string;
  onConfirm?: $TSFixMeFunction;
  onClose?: $TSFixMeFunction;
  intl: intlShape;
};

type State = $TSFixMe;

export class DeleteActionButton extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.onConfirm = this.onConfirm.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClick = this.onClick.bind(this);
    this.state = {
      showModal: false,
    };
  }

  onClick() {
    this.setState({ showModal: true });
  }

  onConfirm() {
    this.setState({ showModal: false });
    if (this.props.onConfirm) {
      this.props.onConfirm();
    }
  }

  onClose() {
    this.setState({ showModal: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  render() {
    const { id, label, intl, modalTitle, modalMessage, disabled } = this.props;

    const modal = disabled ? null : (
      <ConfirmationModal
        id="delete-modal"
        show={this.state.showModal}
        titleText={modalTitle}
        messageText={modalMessage}
        onConfirm={this.onConfirm}
        onClose={this.onClose}
      />
    );

    return (
      <span>
        <ActionButton
          id={id}
          label={label}
          defaultLabel={intl.formatMessage({ id: "button.delete" })}
          icon="icon-eh-delete"
          onClick={this.onClick}
          disabled={disabled}
        />
        {modal}
      </span>
    );
  }
}

export default injectIntl(DeleteActionButton);
